// components/CheatPrevention.js
import { useEffect } from 'react';

const CheatPrevention = ({ onViolation }) => {
  useEffect(() => {
    // Tab visibility detection
    const handleVisibilityChange = () => {
      if (document.hidden) {
        onViolation();
      }
    };

    // Fullscreen change detection
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        onViolation();
      }
    };

    // Prevent right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      onViolation();
    };

    // Prevent keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.ctrlKey && (e.key === 'c' || e.key === 'v' || e.key === 'u') ||
        e.key === 'F12' ||
        e.key === 'F11' ||
        (e.altKey && e.key === 'Tab')
      ) {
        e.preventDefault();
        onViolation();
      }
    };

    // Prevent copy-paste
    const handleCopy = (e) => {
      e.preventDefault();
      onViolation();
    };

    const handleCut = (e) => {
      e.preventDefault();
      onViolation();
    };

    const handlePaste = (e) => {
      e.preventDefault();
      onViolation();
    };

    // Event listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCut);
    document.addEventListener('paste', handlePaste);

    // Request fullscreen
    const requestFullscreen = async () => {
      try {
        await document.documentElement.requestFullscreen();
      } catch (err) {
        console.log('Fullscreen not supported');
      }
    };

    requestFullscreen();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCut);
      document.removeEventListener('paste', handlePaste);
    };
  }, [onViolation]);

  return null;
};

export default CheatPrevention;